import React from 'react';
import { getAntdLocale } from './AntdLocalization';
import AntdConfigProvider from 'antd/lib/config-provider';

export const LocalizationConfig = (props: React.PropsWithChildren<unknown>) => {
   return (
      <AntdConfigProvider locale={getAntdLocale()}>
         {props.children}
      </AntdConfigProvider>
   );
};
